import apiClient from '../client'

export interface ParishPayload {
  name?: string
  address?: string
  city?: string
  state?: string
  zip_code?: string
  office_address_same?: boolean
  office_address?: string
  phone_numbers?: string[]
  email_addresses?: string[]
  website?: string
  diocese?: string
  timezone?: string
  show_snack_warning_to_teachers?: boolean
  snack_warning_message?: string
  notes?: string
}

export interface ParishDetailResponse extends ParishResponse {
  address?: string
  city?: string
  state?: string
  zip_code?: string
  phone_numbers?: string[]
  email_addresses?: string[]
  website?: string
  diocese?: string
  timezone?: string
  show_snack_warning_to_teachers?: boolean
  snack_warning_message?: string
  notes?: string
}

export interface ParishResponse {
  id: string
  name: string
  sharecode?: string
}

export const parishesApi = {
  async list(): Promise<ParishResponse[]> {
    const { data } = await apiClient.get<ParishResponse[]>('/api/v1/parishes')
    return data
  },
  async get(parishId: string): Promise<ParishDetailResponse> {
    const { data } = await apiClient.get<ParishDetailResponse>(`/api/v1/parishes/${parishId}`)
    return data
  },
  async create(payload: ParishPayload): Promise<ParishResponse> {
    const { data } = await apiClient.post<ParishResponse>('/api/v1/parishes', payload)
    return data
  },
  async update(parishId: string, payload: Partial<ParishPayload>): Promise<ParishResponse> {
    const { data } = await apiClient.put<ParishResponse>(`/api/v1/parishes/${parishId}`, payload)
    return data
  },
  async switch(parishId: string): Promise<{ message: string; parish_id: string; parish_name: string }> {
    const { data } = await apiClient.post(`/api/v1/parishes/${parishId}/switch`)
    return data
  },
  async delete(parishId: string): Promise<{ message: string }> {
    const { data } = await apiClient.delete(`/api/v1/parishes/${parishId}`)
    return data
  },
  async generateRegistrationPDF(
    parishId: string,
    pdfData: {
      first_day?: string
      last_month?: string
      use_school_year?: boolean
      class_days?: string
      class_time?: string
      class_ids?: string[]
    }
  ): Promise<Blob> {
    const { data } = await apiClient.post(
      `/api/v1/parishes/${parishId}/registration-pdf`,
      pdfData,
      { responseType: 'blob' }
    )
    return data
  },
}



